import {
  Alert,
  AlertIcon,
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  ButtonGroup,
  Flex,
  Heading,
  Stack,
  useToast,
} from '@chakra-ui/react';
import PPEResource from 'api/ppe';
import PPEForm from 'components/ppe/PPEForm';
import { strings } from 'config/localization';
import routes from 'constants/routes';
import { PPESchema } from 'constants/schema';
import React, { useRef, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useMutation, useQueryClient } from 'react-query';
import { Link as RouterLink, useHistory } from 'react-router-dom';

const CreatePPE: React.FC = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const form = useRef() as React.MutableRefObject<HTMLFormElement>;
  const history = useHistory();
  const methods = useForm<PPESchema>();
  const ppeAPI = new PPEResource();

  const [errorMessage, setErrorMessage] = useState<PPESchema>();

  const addPPE = useMutation((data: any) => ppeAPI.store(data), {
    onSuccess: (res: any) => {
      toast({
        title: strings.ppe_success_msg,
        description: res.data.email,
        status: 'success',
        isClosable: true,
      });
      queryClient.invalidateQueries('ppeList');
      history.push(routes.ppe.list);
    },
    onError: (error: any) => {
      setErrorMessage(error?.response?.data?.message);
    },
  });

  const onSubmit = (data: any) => {
    const formData = {
      company: data?.company?.value,
      name: data?.name,
      is_active: true,
      is_mandatory: data?.is_mandatory
    }
    addPPE.mutate(formData);
  };

  return (
    <Stack direction="column" spacing="4">
      <Breadcrumb color="gray.400" size="4">
        <BreadcrumbItem>
          <BreadcrumbLink as={RouterLink} to={routes.ppe.list}>
            {strings.ppe_management}
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbItem isCurrentPage color="gray.900">
          <BreadcrumbLink as={RouterLink} to={routes.ppe.create}>
            {strings.add_new_ppe}
          </BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>

      <Flex justify="space-between">
        <Heading size="md">{strings.add_new_ppe}</Heading>
      </Flex>

      <Box bg="white" p={['3', '6']} shadow="box" rounded="sm">
        <FormProvider {...methods}>
          <form ref={form} onSubmit={methods.handleSubmit(onSubmit)}>
            <Stack direction="column" spacing="4">
              {addPPE.isError && (
                <Alert status="error">
                  <AlertIcon />
                  {errorMessage ? errorMessage : strings.ppe_creation_failed}
                </Alert>
              )}
              <PPEForm />
              <ButtonGroup>
                <Button
                  colorScheme="primary"
                  type="submit"
                  isLoading={addPPE.isLoading}>
                  {strings.add_ppe}
                </Button>
                <Button variant="outline" onClick={() => history.goBack()}>
                  {strings.cancel}
                </Button>
              </ButtonGroup>
            </Stack>
          </form>
        </FormProvider>
      </Box>
    </Stack>
  );
};

export default CreatePPE;
